import React from 'react';
import styled from 'styled-components';
import styles from '../../../styles';
import { Icon } from '../../../icons';
import { Button } from './';

const jsonp = (url, successCallback, errorCallback) => {
  const callbackName = 'jsonp_callback_' + Math.round(100000 * Math.random());
  window[callbackName] = data => {
    delete window[callbackName];
    document.body.removeChild(script);
    successCallback(data);
  };

  const script = document.createElement('script');
  script.onerror = data => {
    delete window[callbackName];
    document.body.removeChild(script);
    errorCallback(data);
  };
  script.src = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'c=' + callbackName;
  document.body.appendChild(script);
};

const Form = styled.form`
  margin-bottom: 4rem;

  div.fieldContainer {
    display: flex;
    flex-direction: column-reverse;
    border-bottom: 1px solid ${styles.color.ORANGE};
    line-height: 1.75rem;
    margin-bottom: 2rem;
    padding-top: 2rem;
    ${props =>
      props.breakpoint !== 'phone' &&
      `
    max-width: calc(50% - 3.75rem);
    position: relative;
    `} &.checkbox {
      max-width: unset;
      border: 0;
      flex-direction: row;
    }
  }

  label,
  input,
  select {
    margin: 0;
    padding: 0;
    outline: 0;
    font-family: inherit;
    background-color: transparent;
    border: 0;
    appearance: unset;
    line-height: inherit;
  }

  label,
  input {
    font-size: 1.4375rem;
  }

  select.hasValue {
    font-size: 1.4375rem;
  }

  label:not(.checkbox) {
    color: ${styles.color.ORANGE};
    position: absolute;
    pointer-events: none;
  }

  label.select {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;

    svg {
      width: 1rem;
      height: 1rem;
    }
  }

  select.hasValue + label,
  select:focus + label {
    svg {
      display: none;
    }
  }

  label.checkbox {
    display: flex;
    align-items: center;
  }

  input[type='checkbox'] {
    border: 1px solid ${styles.color.ORANGE};
    width: 1.5rem;
    height: 1.5rem;
    margin-right: 1rem;
    position: relative;
    flex-shrink: 0;
    ${props =>
      props.breakpoint === 'phone' &&
      `
      align-self: flex-start;
    `} &:after {
      content: '\\2713 ';
      color: inherit;
      width: 1.5rem;
      height: 1.5rem;
      text-align: center;
      line-height: inherit;
      font-family: inherit;
      display: none;
    }

    &:checked {
      &:after {
        display: block;
      }
    }
  }

  input:focus + label,
  input.hasValue + label,
  select:focus + label,
  select.hasValue + label {
    font-size: 1rem;
    margin-top: -1.35rem;
  }

  div.error {
    bottom: -1.75rem;
    position: absolute;
    color: #f00;
  }
`;

const MailchimpResult = styled.p`
  font-family: ApercuBold;
`;

class PlayTestForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      formData: {
        FNAME: '',
        LNAME: '',
        EMAIL: '',
        MMERGE3: '',
        MMERGE4: '',
        MMERGE5: '',
        MMERGE6: '',
        gdpr: '',
        b_47ad524267d1069fc9b9de086_8da4c8d6e3: '',
      },
      mailChimpMessage: '',
      showErrors: false,
      isSubmitting: false,
      submitCompleted: false,
      errors: [],
      formError: '',
      touchedFields: [],
      isValid: false,
    };
  }

  onInputChange = event => {
    const { target: { name, value, type, checked } } = event;
    const { formData } = this.state;
    value !== ''
      ? event.target.classList.add('hasValue')
      : event.target.classList.remove('hasValue');
    this.setState(
      {
        formData: {
          ...formData,
          [name]: type !== 'checkbox' ? value : checked,
        },
      },
      () => {
        this.validate();
      }
    );
  };

  isValidEmail = email => {
    const regex = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
    return regex.test(email);
  };

  isValidString = str => {
    return str.length > 0;
  };

  isValidCheckboxValue = val => {
    return val;
  };

  validate = () => {
    const { formData: { FNAME, LNAME, EMAIL, MMERGE3, MMERGE4, MMERGE5, MMERGE6, gdpr } } = this.state;

    const errors = [];
    if (!this.isValidEmail(EMAIL)) {
      errors.push('EMAIL');
    }
    if (!this.isValidString(FNAME)) {
      errors.push('FNAME');
    }
    if (!this.isValidString(LNAME)) {
      errors.push('LNAME');
    }
    if (!this.isValidString(MMERGE3)) {
      errors.push('MMERGE3');
    }
    if (!this.isValidString(MMERGE4)) {
      errors.push('MMERGE4');
    }
    if (!this.isValidString(MMERGE5)) {
      errors.push('MMERGE5');
    }
    if (!this.isValidString(MMERGE6)) {
      errors.push('MMERGE6');
    }
    if (!this.isValidCheckboxValue(gdpr)) {
      errors.push('gdpr');
    }
    const isValid = errors.length === 0;
    this.setState({
      errors,
      isValid,
    });
  };

  updateTouchedfields(event) {
    const { name } = event.target;
    if (name === '') return;
    const touchedFields = [
      ...this.state.touchedFields.filter(item => item !== name),
      name,
    ];
    this.setState({
      touchedFields,
    });
  }

  onBlur = event => {
    this.updateTouchedfields(event);
    this.validate();
  };

  submitForm = event => {
    this.validate();
    this.setState({
      showErrors: true,
    });

    const { isValid } = this.state;
    if (!isValid) return;

    this.setState({
      isSubmitting: true,
      formError: '',
      submitCompleted: false,
      submitFailed: false,
    });

    this.doSubmit();
  };

  doSubmit = () => {
    const {
      formData: {
        FNAME,
        LNAME,
        EMAIL,
        MMERGE3,
        MMERGE4,
        MMERGE5,
        MMERGE6,
        gdpr,
        b_47ad524267d1069fc9b9de086_8da4c8d6e3,
      },
    } = this.state;
    const formData = new FormData();
    formData.set('FNAME', FNAME);
    formData.set('LNAME', LNAME);
    formData.set('EMAIL', EMAIL);
    formData.set('MMERGE3', MMERGE3);
    formData.set('MMERGE4', MMERGE4);
    formData.set('MMERGE5', MMERGE5);
    formData.set('MMERGE6', MMERGE6);
    formData.set('gdpr[405]', gdpr);
    formData.set(
      'b_47ad524267d1069fc9b9de086_8da4c8d6e3',
      b_47ad524267d1069fc9b9de086_8da4c8d6e3
    );
    const params = Array.from(formData, e =>
      e.map(encodeURIComponent).join('=')
    ).join('&');

    const url = `https://spaceapegames.us5.list-manage.com/subscribe/post-json?u=47ad524267d1069fc9b9de086&amp;id=8da4c8d6e3&${params}`;
    jsonp(
      url,
      response => {
        const { result, msg } = response;
        this.setState({
          mailChimpMessage: msg,
          submitCompleted: result === 'success',
          isSubmitting: false,
        });
      },
      error => {
        console.log(error);
        this.setState({
          mailChimpMessage: 'Error submitting form.',
          submitCompleted: false,
          isSubmitting: false,
        });
      }
    );
  };

  render() {
    const {
      formData: {
        FNAME,
        LNAME,
        EMAIL,
        MMERGE3,
        MMERGE4,
        MMERGE5,
        MMERGE6,
        gdpr,
        b_47ad524267d1069fc9b9de086_8da4c8d6e3,
      },
      errors,
      touchedFields,
      showErrors,
      isSubmitting,
      submitCompleted,
      mailChimpMessage,
    } = this.state;

    return (
      <React.Fragment>
        {!submitCompleted && (
          <React.Fragment>
            <Form
              breakpoint={this.props.breakpoint}
              noValidate
              autoComplete="off"
              autoCorrect="off"
              spellCheck="false"
            >
              <div className="fieldContainer">
                {errors.indexOf('FNAME') > -1 &&
                  (touchedFields.indexOf('FNAME') > -1 || showErrors) && (
                    <div className="error">Your first name is required.</div>
                  )}
                <input
                  id="mce-FNAME"
                  name="FNAME"
                  type="text"
                  value={FNAME}
                  onChange={this.onInputChange}
                  onBlur={this.onBlur}
                />
                <label htmlFor="mce-FNAME">
                  First name <span className="asterisk">*</span>
                </label>
              </div>
              <div className="fieldContainer">
                {errors.indexOf('LNAME') > -1 &&
                  (touchedFields.indexOf('LNAME') > -1 || showErrors) && (
                    <div className="error">Your last name is required.</div>
                  )}
                <input
                  id="mce-LNAME"
                  name="LNAME"
                  type="text"
                  value={LNAME}
                  onChange={this.onInputChange}
                  onBlur={this.onBlur}
                />
                <label htmlFor="mce-LNAME">
                  Last name <span className="asterisk">*</span>
                </label>
              </div>

              <div className="fieldContainer">
                {errors.indexOf('EMAIL') > -1 &&
                  (touchedFields.indexOf('EMAIL') > -1 || showErrors) && (
                    <div className="error">A valid email address is required.</div>
                  )}
                <input
                  id="mce-EMAIL"
                  name="EMAIL"
                  type="email"
                  value={EMAIL}
                  onChange={this.onInputChange}
                  onBlur={this.onBlur}
                />
                <label htmlFor="mce-EMAIL">
                  Email address <span className="asterisk">*</span>
                </label>
              </div>
              
              <div className="fieldContainer">
                {errors.indexOf('MMERGE3') > -1 &&
                  (touchedFields.indexOf('MMERGE3') > -1 || showErrors) && (
                    <div className="error">This field is required.</div>
                  )}
                <select
                  id="mce-MMERGE3"
                  name="MMERGE3"
                  onChange={this.onInputChange}
                  onBlur={this.onBlur}
                  value={MMERGE3}
                >
                  <option value="" />
                  <option value="Female">Female</option>
                  <option value="Male">Male</option>
                  <option value="Prefer not to say">Prefer not to say</option>
                </select>
                <label htmlFor="mce-MMERGE3" className="select">
                  Gender * <Icon icon="#arrow-down" /> 
                </label>
              </div>
                  
              <div className="fieldContainer">
                {errors.indexOf('MMERGE4') > -1 &&
                  (touchedFields.indexOf('MMERGE4') > -1 || showErrors) && (
                    <div className="error">This field is required.</div>
                  )}
                <select
                  id="mce-MMERGE4"
                  name="MMERGE4"
                  onChange={this.onInputChange}
                  onBlur={this.onBlur}
                  value={MMERGE4}
                >
                  <option value="" />
                  <option value="0 - 12">0 - 12</option>
                  <option value="13 - 17">13 - 17</option>
                  <option value="8 - 24">18 - 24</option>
                  <option value="25 - 34">25 - 34</option>
                  <option value="35 - 44">35 - 44</option>
                  <option value="45+">45+</option>
                  <option value="Prefer not to say">Prefer not to say</option>
                </select>
                <label htmlFor="mce-MMERGE4" className="select">
                  Age * <Icon icon="#arrow-down" /> 
                </label>
              </div>
              
              <div className="fieldContainer">
                {errors.indexOf('MMERGE5') > -1 &&
                  (touchedFields.indexOf('MMERGE5') > -1 || showErrors) && (
                    <div className="error">This field is required.</div>
                  )}
                <select
                  id="mce-MMERGE5"
                  name="MMERGE5"
                  onChange={this.onInputChange}
                  onBlur={this.onBlur}
                  value={MMERGE5}
                >
                  <option value="" />
                  <option value="Android">Android</option>
                  <option value="iOS">iOS</option>
                  <option value="Other">Other</option>
                </select>
                <label htmlFor="mce-MMERGE5" className="select">
                  Device * <Icon icon="#arrow-down" /> 
                </label>
              </div>
                  
              <div className="fieldContainer">
                {errors.indexOf('MMERGE6') > -1 &&
                  (touchedFields.indexOf('MMERGE6') > -1 || showErrors) && (
                    <div className="error">This field is required.</div>
                  )}
                <select
                  id="mce-MMERGE6"
                  name="MMERGE6"
                  onChange={this.onInputChange}
                  onBlur={this.onBlur}
                  value={MMERGE6}
                >
                  <option value="" />
                  <option value="Google">Google</option>
                  <option value="Facebook">Facebook</option>
                  <option value="Employee">Space Ape Employee</option>
                  <option value="Friend">A friend</option>
                  <option value="Promotional">Promotional card</option>
                  <option value="Other">Other</option>
                </select>
                <label htmlFor="mce-MMERGE6" className="select">
                  How did you hear about us? * <Icon icon="#arrow-down" /> 
                </label>
              </div>     
                  
              <div className="fieldContainer checkbox">
                <label className="checkbox" htmlFor="gdpr_405">
                  <input
                    id="gdpr_405"
                    name="gdpr"
                    type="checkbox"
                    value={gdpr}
                    onChange={this.onInputChange}
                    onBlur={this.onBlur}
                  />I agree to be contacted by email by Space Ape Games.
                </label>
                {errors.indexOf('gdpr') > -1 &&
                  (touchedFields.indexOf('gdpr') > -1 || showErrors) && (
                    <div className="error">This field is required.</div>
                  )}
              </div>
              <div
                style={{ position: 'absolute', left: '-5000px' }}
                aria-hidden="true"
              >
                <input
                  tabIndex="-1"
                  name="b_47ad524267d1069fc9b9de086_8da4c8d6e3"
                  type="text"
                  onChange={this.onInputChange}
                  onBlur={this.onBlur}
                  value={b_47ad524267d1069fc9b9de086_8da4c8d6e3}
                />
              </div>
            </Form>
            <div>
              <p>You can unsubscribe at any time by clicking the link in the footer of our emails. Your data will be held in line with our <a href="https://spaceapegames.com/privacy-policy">privacy policy</a>.</p>
            </div>
            {!isSubmitting && (
              <Button onClick={this.submitForm}>Sign up</Button>
            )}
          </React.Fragment>
        )}
        {mailChimpMessage && (
          <MailchimpResult
            dangerouslySetInnerHTML={{ __html: mailChimpMessage }}
          />
        )}
      </React.Fragment>
    );
  }
}

export default PlayTestForm;



// WEBPACK FOOTER //
// ./src/modules/pages/components/PlayTestForm.js